import { render, staticRenderFns } from "./NavSecondary.vue?vue&type=template&id=3a9efdec&"
import script from "./NavSecondary.vue?vue&type=script&lang=js&"
export * from "./NavSecondary.vue?vue&type=script&lang=js&"
import style0 from "./NavSecondary.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* nuxt-component-imports */
installComponents(component, {NavItems: require('/lasso/components/NavItems.vue').default})


/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a9efdec')) {
      api.createRecord('3a9efdec', component.options)
    } else {
      api.reload('3a9efdec', component.options)
    }
    module.hot.accept("./NavSecondary.vue?vue&type=template&id=3a9efdec&", function () {
      api.rerender('3a9efdec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/NavSecondary.vue"
export default component.exports